import { render, staticRenderFns } from "./OrderPriceDeliveryServicesTableMobile.vue?vue&type=template&id=2c629b09&scoped=true"
import script from "./OrderPriceDeliveryServicesTableMobile.vue?vue&type=script&lang=js"
export * from "./OrderPriceDeliveryServicesTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c629b09",
  null
  
)

export default component.exports